import { Box } from "@mui/material";
import { useEffect, useRef } from "react";

const ScrollableBox = ({ onScrollEnd, children, ...props }) => {
  const boxRef = useRef(null);

  const handleScroll = () => {
    if (boxRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = boxRef.current;
      if (scrollTop + clientHeight >= scrollHeight && onScrollEnd) {
        onScrollEnd();
      }
    }
  };

  useEffect(() => {
    const box = boxRef.current;
    if (box) {
      box.addEventListener("scroll", handleScroll);
      return () => {
        box.removeEventListener("scroll", handleScroll);
      };
    }
  }, []);

  return (
    <Box ref={boxRef} {...props}>
      {children}
    </Box>
  );
};

export default ScrollableBox;
